import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable } from 'rxjs'
import { ResetPassword } from '../models/password.model'

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class LostPasswordService {
  constructor(private http: HttpClient) {}

  recoverPassword(email: string): void {
    this.http.post<HttpResponse<null>>('./Api/Core/Auth/Password/Recover', { email }).pipe(untilDestroyed(this)).subscribe()
  }

  resetPassword(data: ResetPassword): Observable<HttpResponse<null>> {
    return this.http.post<HttpResponse<null>>('./Api/Core/Auth/Password/Reset', data)
  }
}
